import React from 'react';
import { Location } from '@reach/router'
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// import { IntercomProvider } from 'react-use-intercom';

import { PersistGate } from 'redux-persist/es/integration/react'

import { Toaster } from 'sonner'

import ThemeTopLayout from 'gatsby-theme-material-ui-top-layout/src/components/top-layout';

import store, { persistor } from '../../state';

// import NavigationTopBarContainer from '../../containers/NavigationTopBarContainer';
import WindowStateManagerContainer from '../../containers/WindowStateManagerContainer';

import useReferralLink from '../../hooks/useQueryParam';

// const INTERCOM_APP_ID = 'zpladqap';

const queryClient = new QueryClient()

export default function TopLayout({ children, theme }) {

  useReferralLink();

  const content = (
    <ThemeTopLayout theme={theme}>
      <Toaster richColors position="bottom-right" />
      {/* <Location>
        {({ location }) => <NavigationTopBarContainer location={location} />}
      </Location> */}
      <Location>
        {({ location }) => <WindowStateManagerContainer location={location} />}
      </Location>
      {children}
    </ThemeTopLayout>
  );

  const wrapWithPersistGate = typeof window !== 'undefined' && window.localStorage;

  return (
    // <IntercomProvider appId={INTERCOM_APP_ID}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          {wrapWithPersistGate ? (
            <PersistGate loading={null} persistor={persistor}>
              {content}
            </PersistGate>
          ) : (
            content
          )}
        </Provider>
      </QueryClientProvider>
    // </IntercomProvider>
  );
}
